import "./../../styles/Reviews.css";

const ReviewFilters = ({
    search,
    setSearch,
    status,
    setStatus,
    rating,
    setRating,
}) => {
    return (
        <div className="review-filters">

            <input
                type="text"
                placeholder="Search reviews..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
            />

            <select
                value={status}
                onChange={(e) => setStatus(e.target.value)}
            >
                <option value="all">All Status</option>
                <option value="approved">Approved</option>
                <option value="pending">Pending</option>
                <option value="hidden">Hidden</option>
            </select>

            <select
                value={rating}
                onChange={(e) => setRating(e.target.value)}
            >
                <option value="all">All Ratings</option>
                <option value="5">5 ⭐</option>
                <option value="4">4 ⭐</option>
                <option value="3">3 ⭐</option>
                <option value="2">2 ⭐</option>
                <option value="1">1 ⭐</option>
            </select>

        </div>
    );
};

export default ReviewFilters;